import ModuleProgressRender from './ModuleProgressRender';

export default ModuleProgressRender;
